import React from 'react';
import { ProductOfferProps } from './ProductOfferProps';
import { CandyRackProductOffer } from './CandyRackProductOffer';
import { SharedLastUpsellCandyCartProductOffer } from './SharedLastUpsellCandyCartProductOffer';

export const ProductOffer = ({
  parentProduct,
  ...restProps
}: ProductOfferProps) => {
  return parentProduct ? (
    <CandyRackProductOffer parentProduct={parentProduct} {...restProps} />
  ) : (
    <SharedLastUpsellCandyCartProductOffer {...restProps} />
  );
};

export default ProductOffer;
